







































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import { PPI_CAKUPAN_ITEMS, ppiCakupanPicker } from "@/utils/unit";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import PpiBundleTrenCard from "@/components/ppi/rekap/PpiBundleTrenCard.vue";
import PpiBundleRekapBulananService, {
  PpiBangsalLaporan,
  PpiBundleTren,
  PpiRekapAnalisaRow,
  PpiRekapLaporan,
  PpiRekapMatriks,
  PpiRekapCakupan,
  PpiRekapMode,
  PpiStatusMonitor,
  PpiStatusPengisian,
  PpiStatusRuangan,
  PpiStatusSel,
  PpiTrenMode,
  PpiUnitScope
} from "@/services/PpiBundleRekapBulananService";

@Component({
  components: { UnitRuangPicker, VCDateTimePicker, PpiBundleTrenCard }
})
export default class PpiBundleRekapBulananPage extends Vue {
  loading = false;
  loadingBangsal = false;
  loadingStatus = false;
  printing = false;
  saving = false;
  signing = false;
  signDialog = false;
  password = "";

  tab = 0;
  mode: PpiRekapMode = "bulanan";
  periode = "";
  unitId: string | null = null;

  cakupan: PpiRekapCakupan = "ranap";

  modeItems = [
    { text: "Harian", value: "harian" },
    { text: "Bulanan", value: "bulanan" },
    { text: "Triwulan", value: "triwulan" },
    { text: "Semester", value: "semester" },
    { text: "Tahunan", value: "tahunan" }
  ];

  triwulanItems = [
    { text: "I (Jan – Mar)", value: 1 },
    { text: "II (Apr – Jun)", value: 2 },
    { text: "III (Jul – Sep)", value: 3 },
    { text: "IV (Okt – Des)", value: 4 }
  ];

  semesterItems = [
    { text: "I (Jan – Jun)", value: 1 },
    { text: "II (Jul – Des)", value: 2 }
  ];

  cakupanItems = PPI_CAKUPAN_ITEMS;

  matriks: PpiRekapMatriks | null = null;
  laporan: PpiRekapLaporan | null = null;
  analisaRows: PpiRekapAnalisaRow[] = [];
  catatan: string | null = null;

  bangsal: PpiBangsalLaporan | null = null;

  statusMonitor: PpiStatusMonitor | null = null;
  hanyaBelumLengkap = true;

  trenMode: PpiTrenMode = "bulanan";
  trenSemua: PpiBundleTren | null = null;
  trenBangsal: PpiBundleTren | null = null;
  loadingTrenSemua = false;
  loadingTrenBangsal = false;
  trenSemuaSeq = 0;
  trenBangsalSeq = 0;

  unitScope: PpiUnitScope = {
    is_kepala_ruang: false,
    unit_id: null,
    unit_nama: null
  };

  async mounted() {
    this.periode = this.periodeDefault();

    await this.loadData();
    if (this.$route.query.tab === "status") {
      this.tab = this.statusTabIndex;
    }
  }

  @Watch("mode")
  onModeChange() {
    this.periode = this.periodeDefault();
    this.matriks = null;
    this.laporan = null;
    this.analisaRows = [];
    this.bangsal = null;
    this.statusMonitor = null;
    this.trenSemua = null;
    this.trenBangsal = null;
    this.trenMode = this.mode === "harian" ? "bulanan" : this.mode;
  }

  @Watch("cakupan")
  onCakupanChange() {
    this.matriks = null;
    this.statusMonitor = null;
    this.bangsal = null;
    this.trenBangsal = null;
    this.loadData();
    if (this.isTabStatus) this.loadStatus();
  }

  @Watch("trenMode")
  onTrenModeChange() {
    if (this.matriks && !this.isKepalaRuang) this.loadTrenSemua();
    if (this.bangsal) this.loadTrenBangsal();
  }

  @Watch("tab")
  onTabChange() {
    if (this.isTabStatus && !this.statusMonitor && !this.loadingStatus) {
      this.loadStatus();
    }
  }

  get isBulanan(): boolean {
    return this.mode === "bulanan";
  }

  get pickerCfg() {
    return ppiCakupanPicker(this.isKepalaRuang ? "semua" : this.cakupan);
  }

  get cakupanLabel(): string {
    const item = this.cakupanItems.find(c => c.value === this.cakupan);
    return item ? item.text : this.cakupan;
  }

  get cakupanKosong(): boolean {
    if (this.loading || this.isTabPerBangsal) return false;
    if (this.isTabStatus) {
      return !!this.statusMonitor && this.statusMonitor.ruangan.length === 0;
    }
    return !!this.matriks && this.matriks.ruangan.length === 0;
  }

  get isRentangBulan(): boolean {
    return this.mode === "triwulan" || this.mode === "semester";
  }

  get modeLabelJudul(): string {
    const item = this.modeItems.find(m => m.value === this.mode);
    return item ? item.text : this.mode;
  }

  get kodeRentang(): string {
    return this.mode === "triwulan" ? "Q" : "S";
  }

  get periodeTahun(): string {
    return this.periode.slice(0, 4);
  }

  get periodeKe(): number {
    return Number(this.periode.slice(6)) || 1;
  }

  get periodeKeItems() {
    return this.mode === "triwulan" ? this.triwulanItems : this.semesterItems;
  }

  setPeriodeTahun(tahun: string) {
    this.periode = `${tahun}-${this.kodeRentang}${this.periodeKe}`;
  }

  setPeriodeKe(ke: number) {
    this.periode = `${this.periodeTahun}-${this.kodeRentang}${ke}`;
  }

  get modeLabel(): string {
    const item = this.modeItems.find(m => m.value === this.mode);
    return item ? item.text.toLowerCase() : this.mode;
  }

  get tahunItems(): string[] {
    const kini = new Date().getFullYear();
    const tahun: string[] = [];
    for (let i = 0; i < 6; i++) tahun.push(String(kini - i));
    return tahun;
  }

  get periodeDate(): Date | null {
    const p = this.periode.split("-");
    if (p.length !== 3) return null;
    return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
  }

  setPeriodeDate(val: Date | string | null) {
    if (!val) return;
    const d = val instanceof Date ? val : new Date(val);
    if (isNaN(d.getTime())) return;
    const pad = (n: number) => String(n).padStart(2, "0");
    this.periode = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  periodeDefault(): string {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");

    if (this.mode === "harian") {
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    }
    if (this.mode === "tahunan") {
      return String(now.getFullYear());
    }

    const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    if (this.isRentangBulan) {
      const bulanPerRentang = this.mode === "triwulan" ? 3 : 6;
      const ke = Math.floor(prev.getMonth() / bulanPerRentang) + 1;
      return `${prev.getFullYear()}-${this.kodeRentang}${ke}`;
    }
    return `${prev.getFullYear()}-${pad(prev.getMonth() + 1)}`;
  }

  /**
   * Ka. Bangsal: scope dari server (data kepegawaian), bukan dari unit login.
   * Baginya hanya ada tab Per Bangsal, terkunci ke ruangannya.
   */
  get isKepalaRuang(): boolean {
    return this.unitScope.is_kepala_ruang;
  }

  get statusTabIndex(): number {
    return this.isKepalaRuang ? 1 : 2;
  }

  get isTabStatus(): boolean {
    return this.tab === this.statusTabIndex;
  }

  get isTabPerBangsal(): boolean {
    return !this.isTabStatus && (this.isKepalaRuang || this.tab === 1);
  }

  get ruanganTampil(): PpiStatusRuangan[] {
    if (!this.statusMonitor) return [];

    const urut: Record<PpiStatusPengisian, number> = {
      belum: 0,
      sebagian: 1,
      lengkap: 2
    };

    return this.statusMonitor.ruangan
      .filter(r => !this.hanyaBelumLengkap || r.status !== "lengkap")
      .sort((a, b) => {
        const d = urut[a.status] - urut[b.status];
        return d !== 0 ? d : a.unit_nama.localeCompare(b.unit_nama);
      });
  }

  get isLocked(): boolean {
    return !!(this.laporan && this.laporan.is_locked);
  }

  /** Tanggal TTD dalam format lokal (API mengirim ISO). */
  get signedAt(): string {
    if (!this.laporan || !this.laporan.signed_ketua_ppi_at) return "-";
    const d = new Date(this.laporan.signed_ketua_ppi_at);
    if (isNaN(d.getTime())) return this.laporan.signed_ketua_ppi_at;
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(
      d.getHours()
    )}:${pad(d.getMinutes())}`;
  }

  get signedBy(): string {
    const u: any = this.laporan ? this.laporan.signed_ketua_ppi : null;
    return u && u.identitas ? u.identitas.nama : "";
  }

  /** Header bertingkat: kelompok kolom per bundle (VAP/ISK/IAD/IDO). */
  get bundleGroups(): Array<{ label: string; span: number }> {
    if (!this.matriks) return [];
    const groups: Array<{ label: string; span: number }> = [];
    this.matriks.phases.forEach(p => {
      const last = groups[groups.length - 1];
      if (last && last.label === p.bundle_label) last.span++;
      else groups.push({ label: p.bundle_label, span: 1 });
    });
    return groups;
  }

  async loadData() {
    if (!this.periode) return;
    this.loading = true;
    try {
      const resp = await PpiBundleRekapBulananService.preview(
        this.periode,
        this.mode,
        this.cakupan
      );
      const data = resp.data?.data;
      this.matriks = data?.matriks || null;
      this.laporan = data?.laporan || null;
      this.catatan = this.laporan ? this.laporan.catatan : null;
      this.analisaRows = this.buildAnalisaRows();

      if (data?.unit_scope) {
        this.unitScope = data.unit_scope;
        // Ka. Bangsal: ruangan terkunci ke unitnya, langsung tampilkan rinciannya.
        if (this.unitScope.is_kepala_ruang && this.unitScope.unit_id) {
          this.unitId = this.unitScope.unit_id;
          this.loadPerBangsal();
        }
      }
      if (!this.isKepalaRuang) this.loadTrenSemua();
    } catch (e) {
      this.matriks = null;
      this.laporan = null;
      this.analisaRows = [];
    } finally {
      this.loading = false;
    }
  }

  async loadPerBangsal() {
    if (!this.periode || !this.unitId) return;
    this.loadingBangsal = true;
    this.loadTrenBangsal();
    try {
      const resp = await PpiBundleRekapBulananService.perBangsal(
        this.periode,
        this.unitId,
        this.mode
      );
      this.bangsal = resp.data?.data || null;
    } catch (e) {
      this.bangsal = null;
    } finally {
      this.loadingBangsal = false;
    }
  }

  async loadTrenSemua() {
    if (!this.periode) return;
    const seq = ++this.trenSemuaSeq;
    this.loadingTrenSemua = true;
    try {
      const resp = await PpiBundleRekapBulananService.tren(
        this.trenMode,
        this.periode.slice(0, 4),
        this.cakupan
      );
      if (seq === this.trenSemuaSeq) this.trenSemua = resp.data?.data || null;
    } catch (e) {
      if (seq === this.trenSemuaSeq) this.trenSemua = null;
    } finally {
      if (seq === this.trenSemuaSeq) this.loadingTrenSemua = false;
    }
  }

  async loadTrenBangsal() {
    if (!this.periode || !this.unitId) return;
    const seq = ++this.trenBangsalSeq;
    this.loadingTrenBangsal = true;
    try {
      const resp = await PpiBundleRekapBulananService.tren(
        this.trenMode,
        this.periode.slice(0, 4),
        this.cakupan,
        this.unitId
      );
      if (seq === this.trenBangsalSeq) this.trenBangsal = resp.data?.data || null;
    } catch (e) {
      if (seq === this.trenBangsalSeq) this.trenBangsal = null;
    } finally {
      if (seq === this.trenBangsalSeq) this.loadingTrenBangsal = false;
    }
  }

  async loadStatus() {
    if (!this.periode) return;
    this.loadingStatus = true;
    try {
      const resp = await PpiBundleRekapBulananService.statusPengisian(
        this.periode,
        this.mode,
        this.cakupan
      );
      this.statusMonitor = resp.data?.data || null;
      if (this.statusMonitor?.unit_scope) {
        this.unitScope = this.statusMonitor.unit_scope;
      }
    } catch (e) {
      this.statusMonitor = null;
    } finally {
      this.loadingStatus = false;
    }
  }

  selClass(sel: PpiStatusSel) {
    return sel && sel.n > 0 ? "sel-ada" : "sel-kosong";
  }

  statusColor(status: PpiStatusPengisian) {
    if (status === "belum") return "red darken-2";
    return status === "sebagian" ? "orange darken-2" : "green darken-2";
  }

  statusLabel(status: PpiStatusPengisian) {
    if (status === "belum") return "Belum mengisi";
    return status === "sebagian" ? "Sebagian" : "Lengkap";
  }

  fmtTgl(tanggal: string | null) {
    if (!tanggal) return "";
    const p = tanggal.split("-");
    return p.length === 3 ? `${p[2]}-${p[1]}` : tanggal;
  }

  async cetakPerBangsal() {
    if (!this.periode || !this.unitId) return;
    this.printing = true;
    try {
      await PpiBundleRekapBulananService.printPerBangsalPdf(
        this.periode,
        this.unitId,
        this.mode
      );
    } finally {
      this.printing = false;
    }
  }

  /**
   * Baris analisa = 9 fase bundle. Capaian selalu dari matriks (server-authoritative);
   * teks analisa/RTL diambil dari laporan tersimpan bila ada.
   */
  buildAnalisaRows(): PpiRekapAnalisaRow[] {
    if (!this.matriks) return [];

    const tersimpan: Record<string, PpiRekapAnalisaRow> = {};
    if (this.laporan && this.laporan.analisa) {
      this.laporan.analisa.forEach(row => {
        tersimpan[row.fase_key] = row;
      });
    }

    return this.matriks.phases.map(p => {
      const jml = this.matriks!.jumlah[p.key];
      const prev = tersimpan[p.key];
      return {
        fase_key: p.key,
        fase_label: `${p.bundle_label} — ${p.fase_label}`,
        capaian: jml ? jml.capaian : null,
        kategori: jml ? jml.kategori : "-",
        analisa: prev ? prev.analisa : null,
        rtl: prev ? prev.rtl : null
      };
    });
  }

  async simpan() {
    this.saving = true;
    try {
      const resp = await PpiBundleRekapBulananService.save({
        periode: this.periode,
        catatan: this.catatan,
        analisa: this.analisaRows.map(r => ({
          fase_key: r.fase_key,
          analisa: r.analisa,
          rtl: r.rtl
        }))
      });
      this.laporan = resp.data?.data || null;
      this.analisaRows = this.buildAnalisaRows();
      appModule.sendSuccessNotice("Draft laporan tersimpan.");
    } finally {
      this.saving = false;
    }
  }

  async doSign() {
    if (!this.laporan) return;
    this.signing = true;
    try {
      const resp = await PpiBundleRekapBulananService.signKetuaPpi(this.laporan.id, {
        password: this.password
      });
      this.laporan = resp.data?.data || null;
      this.password = "";
      this.signDialog = false;
      await this.loadData();
      appModule.sendSuccessNotice("Laporan ditandatangani Ketua Komite PPI.");
    } finally {
      this.signing = false;
    }
  }

  async cetak() {
    if (this.isBulanan && this.laporan) {
      PpiBundleRekapBulananService.printPdf(this.laporan.id);
      return;
    }

    this.printing = true;
    try {
      await PpiBundleRekapBulananService.printMatriksPdf(
        this.periode,
        this.mode,
        this.cakupan
      );
    } finally {
      this.printing = false;
    }
  }

  fmt(val: number | null): string {
    if (val === null || val === undefined) return "0";
    return val.toFixed(2).replace(".", ",");
  }

  /** Per bangsal: item yang tidak dinilai ditampilkan "—", bukan 0%. */
  fmtDash(val: number | null): string {
    if (val === null || val === undefined) return "—";
    return val.toFixed(2).replace(".", ",");
  }

  kategoriClass(kategori: string): string {
    if (kategori === "baik") return "kat-baik";
    if (kategori === "intermediate") return "kat-intermediate";
    if (kategori === "minimal") return "kat-minimal";
    return "";
  }
}
